if (!customElements.get('price-range')) {
    class PriceRange extends HTMLElement {
        inRangeColor = "#949494";
        outRangeColor = "#000000";
        constructor() {
            super();
            this.init();
        }

        init() {
            this.sliderBar = this.querySelector('.price-range__sliders')
            this.minNumberInput = this.querySelector('[data-id="price-range-number-min"]');
            this.maxNumberInput = this.querySelector('[data-id="price-range-number-max"]');
            this.minSliderInput = this.querySelector('.price-range-slider-min');
            this.maxSliderInput = this.querySelector('.price-range-slider-max');
            this.minValue = Number(this.minNumberInput.min);
            this.maxValue = Number(this.maxNumberInput.max);
            this.timeout = null;
            this.addEventListener('input', this.handleInput.bind(this));
            this.updateNumberInputs();
        }

        /**
         * Handles 'input' events on the price range component.
         * @param {object} evt - Event object.
         */
        handleInput(evt) {
            if (evt.detail !== undefined) {
                clearTimeout(this.timeout);

                this.timeout = setTimeout(() => {
                    this.updateSliderInputs(evt);
                    this.updateNumberInputs();
                }, 500);
            } else {
                this.updateSliderInputs(evt);
                this.updateNumberInputs();
            }
        }

        /**
         * Updates the value of the 'number' type inputs.
         */
        updateNumberInputs() {
            this.minNumberInput.value =
                this.minSliderInput.value !== this.minNumberInput.min ? this.minSliderInput.value : this.minNumberInput.min;

            this.maxNumberInput.value =
                this.maxSliderInput.value !== this.maxNumberInput.max ? this.maxSliderInput.value : this.maxNumberInput.max;


                const rangeDistance = this.maxNumberInput.max - this.minNumberInput.min;

                // Left most value. When moving it, can only go as far as to
                const fromPosition = Math.min(this.minNumberInput.value, this.maxNumberInput.value) - this.minNumberInput.min
            
                // Rightmost value. When moving it, can only go as low 
                const toPosition = Math.max(this.minNumberInput.value, this.maxNumberInput.value) - this.minNumberInput.min
            
                this.sliderBar.style.background = `linear-gradient(
                  to right,
                  ${this.inRangeColor} 0%,
                  ${this.inRangeColor} ${(fromPosition) / (rangeDistance) * 100}%,
                  ${this.outRangeColor} ${((fromPosition) / (rangeDistance)) * 100}%,
                  ${this.outRangeColor} ${(toPosition) / (rangeDistance) * 100}%, 
                  ${this.inRangeColor} ${(toPosition) / (rangeDistance) * 100}%, 
                  ${this.inRangeColor} 100%)`;
            
                this.minNumberInput.parentElement.style.left = `calc(${fromPosition / rangeDistance * 100}% - 18px)`
                this.maxNumberInput.parentElement.style.left = `calc(${toPosition / rangeDistance * 100}% - 18px)`
        }

        /**
         * Updates the value of the 'range' type inputs.
         * @param {object} evt - Event object.
         */
        updateSliderInputs(evt) {
            const minValue = parseInt(this.minNumberInput.value, 10);
            const maxValue = parseInt(this.maxNumberInput.value, 10);

            if (minValue > maxValue - 10) {
                if (evt.target === this.minNumberInput) {
                    this.maxSliderInput.value = minValue + 10;

                    if (maxValue === this.maxValue) {
                        this.minSliderInput.value = this.maxValue - 10;
                    }
                } else {
                    this.minSliderInput.value = maxValue - 10;
                }
            }

            if (maxValue < minValue + 10) {
                if (evt.target === this.maxNumberInput) {
                    this.minSliderInput.value = maxValue - 10;

                    if (minValue === this.minValue) {
                        this.maxSliderInput.value = 10;
                    }
                } else {
                    this.maxSliderInput.value = minValue + 10;
                }
            }

            if (evt.target === this.minNumberInput) {
                this.minSliderInput.value = minValue || Number(this.minNumberInput.min);
            }

            if (evt.target === this.maxNumberInput) {
                this.maxSliderInput.value = maxValue || Number(this.maxNumberInput.max);
            }
        }
    }

    customElements.define('price-range', PriceRange);
}
